module.exports = __webpack_public_path__ + "static/img/parent-intro-section-bg-img.da7accb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parent-intro-section-bg-img.jpg
// module id = vy9i
// module chunks = 3